// Dialpad Mini Dialer (CTI): Dialpad's own calling UI in an iframe. It's how reps
// answer inbound calls in Honey, since Dialpad's REST API can't answer a call.
// https://developers.dialpad.com/docs/dialpad-mini-dialer
export const CTI_ORIGIN = 'https://dialpad.com';
export const CTI_URL = `${CTI_ORIGIN}/apps/open`;
export const CTI_ALLOW =
  'microphone; speaker-selection; autoplay; camera; display-capture; hid';
export const CTI_SANDBOX =
  'allow-popups allow-scripts allow-same-origin allow-forms';

const API = 'opencti_dialpad';

export const ctiMessage = (method, payload) => ({
  api: API,
  version: '1.0',
  method,
  ...(payload && { payload }),
});

/** The CTI message in a window `message` event, or null if it isn't one from Dialpad. */
export function parseCtiEvent(event) {
  if (!event || event.origin !== CTI_ORIGIN) {
    return null;
  }

  let { data } = event;

  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch {
      return null;
    }
  }

  if (!data || data.api !== API || !data.method) {
    return null;
  }

  return {
    method: data.method,
    payload: data.payload || {},
  };
}

/** Who is calling, from a `call_ringing` payload. */
export function ringingCaller(payload = {}) {
  const contact = payload.contact || {};

  return (
    contact.name || payload.external_number || contact.phone || 'Unknown caller'
  );
}
